import type { FaireProductEntity } from "../../entity_types/product";

export const p_x66fr5wv5w: FaireProductEntity = {
  token: "p_x66fr5wv5w",
  type: "product",
  name: "Cement Pumpkin Planter",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl: "https://cdn.faire.com/fastly/3b85a9028e7cb6f0d1c7ecc8987b6b6d3259933ab4b2aafa416019f09b45bff5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fffeefa6e443b5696ef1335c925bcbcd8014c8b7814f167ab98bb8de69944122.jpeg",
    "https://cdn.faire.com/fastly/1b0ddab418dd594917ac607e2f79ddf9d5f3c93e7ad933609a0e5d671965ad0d.jpeg",
    "https://cdn.faire.com/fastly/227fa428cfd01fcab9bda9cb7c6af7ce7fd3cf244e1a25c8a862f4de320c1865.jpeg",
    "https://cdn.faire.com/fastly/311aa76c27aca9a9d6803fc3c92d247c9cdbd76facc44ade1115e2c47488acae.jpeg",
    "https://cdn.faire.com/fastly/1963872649eab69c8f9db66d1aa8dff613c90382755de2a2a9b8335042ed15dd.jpeg",
    "https://cdn.faire.com/fastly/f5d92e463cb7a4abe2285b30c1f7bf471d6a2098dc982aad289498b17b6bcfee.jpeg",
    "https://cdn.faire.com/fastly/3214b329cfa031371c49d35e3551ac921b288a1c6898c018d26dbd0a7064fd8e.jpeg",
    "https://cdn.faire.com/fastly/8b05080d5298dd1390b12d584ef3352e7fddb4b0977c3eed0e6af089fa3514bc.jpeg",
    "https://cdn.faire.com/fastly/97a81017f74468078e263805089a65c612b049d7e89dce9f38da960202c33520.jpeg",
    "https://cdn.faire.com/fastly/1b6f5c49f7f67fb61c1aee586e7101cf0e33ac47773f8f28e2bff205501a48d4.jpeg",
    "https://cdn.faire.com/fastly/bb3c4efb52cf0d36cbcaedadd3b7932fc6370130e22f48f8d5b8b5e7b7293874.jpeg",
    "https://cdn.faire.com/fastly/e32073446df88c566c9987e4eca2129221ab5dcd4e92e99076a83bf421b1db56.jpeg",
    "https://cdn.faire.com/fastly/e6ef2f71c0d828778ae88f545622d3b1357c42180e7b871526677b667df47816.jpeg",
    "https://cdn.faire.com/fastly/a1935b86ed52602960c7a995a71fc0e8f2b806c64c1caad0cbb4a3329e7dae32.jpeg"
  ],
  priceDollars: 20,
  description: "Give your favorite flowers a fabulous home for fall with this Pumpkin Planter. Crafted out of cement to reflect the season's most famous gourd, this rustic orange-colored planter makes an elegant complement to the brightest of blooms to help elevate your autumn style. Available in large low (6.5\"W), large tall (8.5\"H), small low (5.5\"W), Extra Small Low (4\"W) sizes.",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:16.054Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
